import FooterSecondaryLinks from './FooterSecondaryLinks';

export default FooterSecondaryLinks;
